// extracted by mini-css-extract-plugin
export default {"submitBtnCol":"AddOrEditModal_submitBtnCol__ou5r9","submitBtn":"AddOrEditModal_submitBtn__7DmZj"};